import styled from '@emotion/styled';
import { colors } from 'component-library';

export const NotificationImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
  background-color: ${colors.background.green};
  border-radius: 16px;
`;

export const NotificationIconWrapper = styled.div`
  width: 200px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.base.white};
  border-radius: 50%;
  margin: 32px auto;
  position: relative;
`;

export const CountIconWrapper = styled.div`
  position: absolute;
  top: 30px;
  right: 42px;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #db5658;
  border-radius: 50%;
  color: ${colors.base.white};
  font-size: 26px;
`;
